import React, { PureComponent } from 'react'
import classnames from 'classnames'
import { Link } from '@mui/icons-material'

const gen_url =
  'https://www.vu.edu.au/vu-english/english-language-courses/general-english'
const eap_url =
  'https://www.vu.edu.au/vu-english/english-language-courses/english-for-academic-purposes-eap'

const Unit = ({
  code,
  name,
  focused,
  children,
  creditPoints,
  campus,
  attendanceMode,
  core = false,
  onEdit = event => {},
  onRemove = event => {},
  disabled = false,
  virtual = false,
  withdrawable = false,
  title = '',
  hasRequisite = false
}) => {
  return (
    <div className={classnames('unit-container', { 'unit-container--focused': focused }, { 'unit-container--disabled': disabled }, { 'unit-container--virtual': virtual })} title={title}>
      <div className={classnames('unit', 'unit-front', { 'unit-core': core }, { 'unit-prerequisite': hasRequisite })}>
        <h3 className="unit-code">{code}</h3>
        <p className="credit-points-container">
          {hasRequisite ? (
            <span className="icon-prerequisite">
              <Link /> &nbsp; |
            </span>
          ) : null}

          <span className="credit-points">{creditPoints}</span>
        </p>
        <p className="unit-name">{name}</p>
        <p className="unit-attendance-mode">
          <span>{attendanceMode}</span>
        </p>
        <p className="unit-campus">{campus}</p>
      </div>
      <div className={classnames('unit', 'unit-back', { 'unit-core': core })}>{children}</div>
    </div>
  )
}

export class EditUnit extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      focused: false
    }
  }

  render() {
    const {
      onEdit = event => {},
      onRemove = event => {},
      onWithdraw = event => {},
      disabled = false,
      virtual = false,
      ...other
    } = this.props

    var unitcode = other.code
    var unit_details_url =
      unitcode.indexOf('GEN') != -1
        ? gen_url
        : unitcode.indexOf('EAP') != -1 || unitcode.indexOf('IEL') != -1
        ? eap_url
        : `https://www.vu.edu.au/units/${unitcode}`

    return (
      <Unit
        virtual={virtual}
        disabled={disabled}
        {...other}
        focused={this.state.focused}
      >
        <a
          onFocus={() => this.setState({ focused: true })}
          onBlur={() => this.setState({ focused: false })}
          className="btn"
          href={unit_details_url}
          target="_blank"
          tabIndex={disabled ? '-1' : '0'}
        >
          Unit details
        </a>
        {this.props.editable ? (
          <button
            onFocus={() => this.setState({ focused: true })}
            onBlur={() => this.setState({ focused: false })}
            className="btn"
            onClick={onEdit}
            tabIndex={disabled ? '-1' : '0'}
          >
            Choose Delivery
          </button>
        ) : null}
        {this.props.removeable ? (
          <button
            onFocus={() => this.setState({ focused: true })}
            onBlur={() => this.setState({ focused: false })}
            className="btn"
            onClick={onRemove}
            tabIndex={disabled ? '-1' : '0'}
          >
            Remove
          </button>
        ) : null}
        {this.props.withdrawable ? (
          <button
            onFocus={() => this.setState({ focused: true })}
            onBlur={() => this.setState({ focused: false })}
            className="btn"
            onClick={onWithdraw}
            tabIndex={disabled ? '-1' : '0'}
          >
            Withdraw
          </button>
        ) : null}
      </Unit>
    )
  }
}

export class AddUnit extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      focused: false
    }
  }

  render() {
    const { onAdd = event => {}, disabled = false, ...other } = this.props
    var unitcode = other.code
    var unit_details_url = unitcode.indexOf('GEN') != -1 ? gen_url : unitcode.indexOf('EAP') != -1 || unitcode.indexOf('IEL') != -1 ? eap_url : `https://www.vu.edu.au/units/${unitcode}`

    return (
      <Unit disabled={disabled} {...other} focused={this.state.focused} title={`${other.code} - ${other.name} - ${other.campus} - ${other.attendanceMode}`}>
        <a
          onFocus={() => this.setState({ focused: true })}
          onBlur={() => this.setState({ focused: false })}
          className="btn"
          href={unit_details_url}
          target="_blank"
          tabIndex={disabled ? '-1' : '0'}
        >
          Unit details
        </a>
        <button onFocus={() => this.setState({ focused: true })} onBlur={() => this.setState({ focused: false })} className="btn" onClick={onAdd} tabIndex={disabled ? '-1' : '0'}>
          {' '}
          Add{' '}
        </button>
      </Unit>
    )
  }
}